import React from 'react';

import { ArrowLinkButtonProps } from 'Elements/Button/Arrow';

import { Wrapper, Container, StyledButton, SupportBlockHeading } from './SupportBlock.styled';

export interface Props {
    heading: string | React.ReactElement;
    text: string | React.ReactNode;
    button?: ArrowLinkButtonProps;
    clearingPromise?: boolean;
}

const SupportBlock: React.FC<Props> = props => {
    const { button, text, heading, clearingPromise = false } = props;

    return (
        <Wrapper>
            <Container $hasButton={button ? true : false} $clearingPromise={clearingPromise}>
                <SupportBlockHeading $clearingPromise={clearingPromise}>
                    {heading}
                </SupportBlockHeading>
                {typeof text === 'string' ? <p>{text}</p> : <div>{text}</div>}
            </Container>
            {button && <StyledButton {...button} />}
        </Wrapper>
    );
};

export default SupportBlock;
